<template>
  <!-- Modal -->
  <div class="modal-overlay" @click="$emit('close')">
    <div class="modal" @click.stop>
      <button class="close-button" @click="$emit('close')">✖</button>
      <form @submit.prevent="submitForm">
        <h2>Recuperar contraseña</h2>
        <input
          v-model="email"
          type="email"
          placeholder="Tu correo electrónico"
          required
        />
        <button type="submit" class="submit-button">Enviar enlace</button>
        <p v-if="message" class="message">{{ message }}</p>
      </form>
    </div>
  </div>
  <LoadingModel :visible="loading" />
</template>

<script>
import api from "@/api/axios/axios.js";
import LoadingModel from "@/components/Global/Loading.vue";
export default {
  name: "ResetPass",
  components:{
    LoadingModel,
  },
  data() {
    return {
      loading:false,
      email: "",
      message: "",
      showModal: false,
    };
  },
  methods: {
    async submitForm() {
      try {
        this.loading=true
        await api.post("login/reset/password/", { email: this.email });
        this.message = "Enlace enviado. Revisa tu correo";
        this.error = "";
        this.loading=false
      } catch (err) {
        this.loading=false
        this.showModal = false;
        this.email = "";
        this.message =
          err.response?.data?.error || "Algo salio mal en el envio del correo";
      }
    },
  },
};
</script>

<style scoped>
/* Fondo oscuro del modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  transition: opacity 0.3s ease-in-out;
}

/* Estilo del modal */
.modal {
  background: #fff;
  padding: 2rem;
  border-radius: 15px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  position: relative;
  transition: transform 0.3s ease-out;
}

/* Botón de cerrar */
.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background: #fff;
  border: none;
  font-size: 22px;
  font-weight: bold;
  cursor: pointer;
  color: #888;
  transition: color 0.2s;
}

.close-button:hover {
  color: #f00;
}

/* Títulos y texto */
h2 {
  text-align: center;
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #333;
}

/* Estilo del input */
input {
  width: 100%;
  padding: 12px;
  margin: 0.8rem 0;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 1rem;
  outline: none;
  transition: border-color 0.2s;
}

input:focus {
  border-color: #007bff;
}

/* Estilo del botón de envío */
.submit-button {
  width: 100%;
  padding: 12px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.submit-button:hover {
  background-color: #0056b3;
}

/* Mensaje de éxito o error */
.message {
  text-align: center;
  margin-top: 1rem;
  color: #28a745;
  font-weight: bold;
}

.message.error {
  color: #dc3545;
}
</style>
